import React from 'react';

interface StarRatingProps {
    rating: number;
    size?: number;
    gap?: number;
    className?: string;
}

const StarIcon = ({
    fill,
    isHalf = false,
    size = 16
}: {
    fill: string;
    isHalf?: boolean;
    size?: number;
}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            style={{ width: `${size}px`, height: `${size}px` }}
        >
            <defs>
                {isHalf && (
                    <linearGradient id="half-star" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="50%" stopColor="#1F2328" />
                        <stop offset="50%" stopColor="#fff" />
                    </linearGradient>
                )}
            </defs>
            <path
                d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                fill={isHalf ? "url(#half-star)" : fill}
                stroke="#000"
                strokeWidth="2"
                strokeLinejoin="round"
            />
        </svg>
    );
};

const StarRating: React.FC<StarRatingProps> = ({
    rating,
    size = 16,
    gap = 4,
    className = ""
}) => {
    const stars = Array(5).fill(0);

    return (
        <div
            className={`flex items-center ${className}`}
            style={{ gap: `${gap}px` }}
        >
            {stars.map((_, index) => {
                const starValue = index + 1;
                const isFullStar = rating >= starValue;
                const isHalfStar = rating >= starValue - 0.5 && rating < starValue;

                let fill = "#fff";
                if (isFullStar) {
                    fill = "#1F2328";
                }

                return (
                    <div
                        key={index}
                        className="flex items-center justify-center"
                    >
                        <StarIcon
                            fill={fill}
                            isHalf={isHalfStar}
                            size={size}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default StarRating;